import { defineMessages } from "react-intl";

export const messages = defineMessages({
  assignCountriesTitle: {
    id: "cvVIV/",
    defaultMessage: "Assign Countries",
    description: "dialog header",
  },
  assignCountriesDescription: {
    id: "AjInNW",
    defaultMessage: "Choose countries you want to add to shipping zone from list below",
    description: "dialog description",
  },
  searchCountriesLabel: {
    id: "pGDYG5",
    defaultMessage: "Search Countries",
    description: "search label",
  },
  searchCountriesPlaceholder: {
    id: "1rpzrM",
    defaultMessage: "Search by country name",
    description: "search placeholder",
  },
  quickPickSubtitle: {
    id: "f2F1NJ",
    defaultMessage: "Quick Pick",
    description: "section title",
  },
  countriesSubtitle: {
    id: "wgA48T",
    defaultMessage: "Countries A to Z",
    description: "country selection",
  },
  restOfTheWorldCheckbox: {
    id: "K/ic0P",
    defaultMessage: "Rest of the World",
    description: "checkbox label",
  },
  restOfTheWorldCheckboxDescription: {
    id: "G+9nOZ",
    defaultMessage:
      "If selected, this will add all of the countries not selected to other shipping zones",
    description: "checkbox description",
  },
  assignCountriesButton: {
    id: "LHPVg/",
    defaultMessage: "Assign and save",
    description: "assign countries to shipping zone and save, button",
  },
});
